import {Component, Input} from '@angular/core';
import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {ControlContainer, NgForm} from '@angular/forms';
import {ContactModel} from '../../../models/brother-contacts.model';
import {
    MyProjectStatusSelectTranslateEnum
} from '../../../enums/my-project-status-bar-translate.enum';
import {PriceApprovalStatusEnum} from '../../../enums/price-approval-status.enum';
import {ProjectStatusEnum} from '../../../enums/project-status.enum';

@Component({
    selector: 'app-projects-employee-editor',
    templateUrl: './employee-editor.component.html',
    styleUrls: ['./employee-editor.component.scss'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class ProjectsEmployeeEditorComponent extends EditModalSectionBaseComponent {
    public vlContact: any;
    @Input() public forceFormValidationVisibility: boolean;

    constructor(public  editModalService: EditModalService) {
        super(editModalService);
    }

    public getContactChoices(kamContacts: ContactModel[]): string[] {
        return kamContacts.map(contact => contact.name);
    }

    public getContactValues(kamContacts: ContactModel[]): number[] {
        return kamContacts.map(contact => contact.id);
    }

    public getStatusChoices(): string[] {
        let values = this.getStatusValues();
        return values.map( value => MyProjectStatusSelectTranslateEnum[ value ]);
    }

    public getStatusValues(): string[] {
        let keys = [2, 3, 4, 5];
        return keys.map( key => ProjectStatusEnum[key]);
    }

    public onStatusChanged() {
        // console.log('project status changed to value:', this.model.project.status);
    }

    public updateVlContact():void {
        if (this.model && this.model.project && this.model.project.brotherContacts && this.model.project.brotherContacts.kam && this.model.project.brotherContacts.kam.selectedKamContact) {
            const selectedKam = this.model.project.brotherContacts.kam.kamContacts.find( kc => kc.id === this.model.project.brotherContacts.kam.selectedKamContact )
            this.vlContact =  selectedKam.verkaufsLeiter;
        } else {
            this.vlContact = null;
        }
    }

    public getVlContact():string {
        if ( !this.vlContact && this.model && this.model.project) {
            this.updateVlContact();
        }
        return this.vlContact;
    }

    public isStatusSelectDisabled(): boolean {
        return PriceApprovalStatusEnum[this.model.project.priceApprovalStatus] === PriceApprovalStatusEnum.PRICE_APPROVAL_REQUESTED;
    }
}
